import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import { Drawer, Footer, CookieConsent, BreadcrumbsCollapsible } from './components';
import { Home, About, Contact, Multimedia, TerminosCondiciones, AvisoPrivacidad, DynamicContact } from './pages';
// eslint-disable-next-line

const routes = [
  { path: "/", element: <Home /> },
  { path: "/multimedia", element: <Multimedia /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/contact/:name", element: <DynamicContact /> },
  { path: "/terminos_condiciones", element: <TerminosCondiciones /> },
  { path: "/aviso_privacidad", element: <AvisoPrivacidad /> }
];

function App() {
  const [showFooter, setShowFooter] = useState(false);
  const footerRef = useRef(null); // Referencia al elemento observador

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setShowFooter(entry.isIntersecting),
      { threshold: 0.1 }
    );

    const footerElement = footerRef.current;
    if (footerElement) observer.observe(footerElement);

    return () => footerElement && observer.unobserve(footerElement);
  }, []);

  return (
    <Router>
      <Drawer>
        <BreadcrumbsCollapsible />
        <Routes>
          {routes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Routes>
        <div ref={footerRef} style={{ height: "1px", marginBottom: "0px" }}></div>
      </Drawer>
      <CookieConsent />
      <Footer showFooter={showFooter} />
    </Router>
  );
}

export default App;
